var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[(_vm.editableImage)?_c('ImageCropper',{attrs:{"img":_vm.editableImage},on:{"croppedImg":_vm.onCroppedImg}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }